import styled from 'styled-components'

import Field from 'components/Form/components/Field'
import { Value } from 'components/Form/components/Field/styled'

export const TagListFieldStyled = styled(Field)`
  padding: 0.5rem;
  flex-direction: column;

  ${Value} {
    width: 100%;
  }
  > ${Value} {
    > .Field {
      padding: 0;
    }
  }
`
